export const showBadgeOnFavicon = () => {
  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => {
    const prefix =
      favicon.media === '(prefers-color-scheme: dark)'
        ? 'favicon-dark-badge'
        : 'favicon-badge';
    const newFileName = `/${prefix}-${favicon.sizes[[0]]}.png`;
    favicon.href = newFileName;
  });
};

export const initFaviconSwitcher = () => {
  const favicons = document.querySelectorAll('.favicon');

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      favicons.forEach(favicon => {
        const prefix =
          favicon.media === '(prefers-color-scheme: dark)'
            ? 'favicon-dark'
            : 'favicon';
        const oldFileName = `/${prefix}-${favicon.sizes[[0]]}.png`;
        favicon.href = oldFileName;
      });
    }
  });
};
